import { type MutationHookOptions, useMutation } from "@apollo/client";
import { IssueContractPaymentInvoiceMutation } from "../graphql/mutations";
import type {
  IssueContractPaymentInvoiceMutationType,
  IssueContractPaymentInvoiceMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useIssueContractPaymentInvoiceMutation = (
  options?: MutationHookOptions<
    IssueContractPaymentInvoiceMutationType,
    IssueContractPaymentInvoiceMutationVariablesType
  >
) => {
  return useMutation<
    IssueContractPaymentInvoiceMutationType,
    IssueContractPaymentInvoiceMutationVariablesType
  >(IssueContractPaymentInvoiceMutation, options);
};
